var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-jumbotron',[_c('b-container',[_c('h1',{directives:[{name:"label-key",rawName:"v-label-key",value:('MY_NETWORK'),expression:"'MY_NETWORK'"}]},[_vm._v("My Network")])])],1),_c('b-container',[_c('ReportList',{attrs:{"level":_vm.auth.user.selectedAccess.roleLevel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }